import { Pressable, Text, View } from "react-native";
import { router } from "expo-router";
import Feather from "@expo/vector-icons/Feather";

import { cn } from "~/lib/utils";
import { Button, ButtonProps } from "~/ui/Button";

export function StackHeaderTitle(props: { children: React.ReactNode }) {
  return (
    <View className="w-full">
      {typeof props.children === "string" ? (
        <Text className="text-text-primary text-2xl font-semibold">
          {props.children}
        </Text>
      ) : (
        props.children
      )}
    </View>
  );
}

export function StackHeaderBack(props: {
  backPath?: Parameters<typeof router.replace>[0];
}) {
  return (
    <Pressable
      onPress={() =>
        router.canGoBack()
          ? router.back()
          : router.replace(props.backPath ?? "..")
      }
      className="native:-ml-4 w-9"
      accessibilityLabel="Go back"
      hitSlop={4}
    >
      <Text className="text-text-primary">
        <Feather name="chevron-left" size={32} />
      </Text>
    </Pressable>
  );
}

export function StackHeaderLeft(props: {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <View className={cn("web:ml-4", props.className)}>{props.children}</View>
  );
}

export function StackHeaderRight(props: {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <View className={cn("web:mr-4", props.className)}>{props.children}</View>
  );
}

export function HeaderX(props: ButtonProps) {
  return (
    <Button
      {...props}
      variant="secondary"
      size="small"
      className="rounded-lg  p-1"
    >
      <Text className="text-text-primary ">
        <Feather name="x" size={18} />
      </Text>
    </Button>
  );
}

export function ModalHeaderTitle(props: { children: React.ReactNode }) {
  return typeof props.children === "string" ? (
    <Text className="text-text-primary text-center text-lg font-semibold">
      {props.children}
    </Text>
  ) : (
    props.children
  );
}
